import { createContext } from 'react';
export const contextDefault = () => {

}

export const MainContext = createContext(contextDefault);